module.exports = __webpack_public_path__ + "img/92099.9a530d44.svg";